(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vyro-advertorial-v2"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.vs-article').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const reduce=matchMedia('(prefers-reduced-motion: reduce)'),visible=new Set(),videos=[...root.querySelectorAll('video[data-src]')];function update(){videos.forEach(v=>{if(visible.has(v)&&!document.hidden&&!reduce.matches){if(!v.getAttribute('src')){v.src=v.dataset.src;v.load();}v.muted=true;v.play().catch(()=>{v.controls=true;});}else v.pause();if(reduce.matches)v.controls=true;});}const io=new IntersectionObserver(entries=>{entries.forEach(e=>e.isIntersecting?visible.add(e.target):visible.delete(e.target));update();},{threshold:.12});videos.forEach(v=>{v.muted=true;io.observe(v);});reduce.addEventListener('change',update);document.addEventListener('visibilitychange',update);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyro-related-backpacks"] && !Shopify.designMode) return;
  try {
    
function initializeVyroRelated(scope) {
  scope.querySelectorAll('[data-vyro-related]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const track = section.querySelector('.vyro-related__track');
    const prev = section.querySelector('[data-related-prev]');
    const next = section.querySelector('[data-related-next]');
    const update = () => {prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;};
    const move = direction => {const card = track.querySelector('li');const gap = parseFloat(getComputedStyle(track).gap) || 0;track.scrollBy({left:direction * (card.getBoundingClientRect().width + gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
    prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update();
  });
}
initializeVyroRelated(document);
document.addEventListener('shopify:section:load',event=>initializeVyroRelated(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyro-video-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = root => {
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    const cards=[...root.querySelectorAll('.vyro-reels__card')];
    if(!cards.length) return;
    let index=0, visible=false, paused=matchMedia('(prefers-reduced-motion: reduce)').matches, timer;
    const pause=root.querySelector('[data-pause]'), pauseText=pause.textContent, resumeText=root.querySelector('[data-resume]').textContent;
    const update=()=>{
      cards.forEach((card,i)=>{
        let slot=(i-index+cards.length)%cards.length;
        if(slot>Math.floor(cards.length/2)) slot-=cards.length;
        card.dataset.slot=slot;
        const video=card.querySelector('video');
        if(video){if(visible&&!paused&&!document.hidden) video.play().catch(()=>{});else video.pause();}
        card.querySelector('button').setAttribute('aria-pressed',String(slot===0));
      });
      pause.textContent=paused?resumeText:pauseText;
      clearInterval(timer);
      if(visible&&!paused&&!document.hidden) timer=setInterval(()=>{index=(index+1)%cards.length;update();},5000);
    };
    root.querySelector('[data-prev]').onclick=()=>{index=(index-1+cards.length)%cards.length;update();};
    root.querySelector('[data-next]').onclick=()=>{index=(index+1)%cards.length;update();};
    pause.onclick=()=>{paused=!paused;update();};
    cards.forEach((card,i)=>card.querySelector('button').onclick=()=>{index=i;update();});
    let startX;
    root.querySelector('.vyro-reels__stage').addEventListener('pointerdown',e=>{startX=e.clientX;});
    root.querySelector('.vyro-reels__stage').addEventListener('pointerup',e=>{if(startX!==undefined&&Math.abs(e.clientX-startX)>40){index=(index+(e.clientX<startX?1:-1)+cards.length)%cards.length;update();}startX=undefined;});
    const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;update();},{threshold:.15});
    observer.observe(root);
    document.addEventListener('visibilitychange',update);
    document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(root)){clearInterval(timer);observer.disconnect();document.removeEventListener('visibilitychange',update);}});
    update();
  };
  document.querySelectorAll('.vyro-reels').forEach(setup);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.vyro-reels').forEach(setup));
})();

  } catch(e) { console.error(e); }
})();
})();
